import styled from "styled-components"
import Img from "gatsby-image"

export const StyledEnglishImage = styled(Img)`
  object-fit: contain;
  border-radius: 7px;
`
